const defaultProps = require('./default-props');

const slots = [
  {
    slotId: 'menu-bar',
    label: 'Menu bar'
  },
  {
    slotId: 'content',
    label: 'Content'
  },
  {
    slotId: 'footer',
    label: 'Footer area'
  }
];

const templateSettings = [
  {
    type: 'STRING',
    key: 'page_title',
    label: 'Page Title',
    default: 'Gallery Video'
  }
];

export default {
  id: 'VideoPlayerPage',
  name: 'Video Player Page',
  creator: 'FF Web',
  updatedBy: 'Thomas Davison',
  createdAt: 1550088000000,
  updatedAt: 1550088000000,
  slots,
  templateSettings,
  defaultProps
};
